import { TableRow, TableCell } from "@/components/ui/table";
import { flexRender, Table } from "@tanstack/react-table";

interface DivergenceReport {
  id: number;
  username: string;
  userAgent: string;
  service: string;
  callId: string;
  caller: string;
  created: string;
  reason: string;
  message: string;
}

interface DivergenceTableBodyProps {
  table: Table<DivergenceReport>;
  onRowClick?: (id: number) => void;
  selectedId?: number;
}

export function DivergenceTableBody({ table, onRowClick, selectedId }: DivergenceTableBodyProps) {
  const rows = table.getRowModel().rows;

  return (
    <>
      {rows.length > 0 ? (
        rows.map((row) => (
          <TableRow
            key={row.id}
            className="table-row cursor-pointer hover:bg-gray-100"
            data-state={selectedId !== undefined && row.original.id === selectedId ? "selected" : undefined}
            onClick={() => onRowClick?.(row.original.id)}
          >
            {row.getVisibleCells().map((cell, index) => (
              <TableCell
                key={cell.id}
                className={
                  index === row.getVisibleCells().length - 1
                    ? "flex items-center justify-between"
                    : "justify-end space-x-2"
                }
              >
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </TableCell>
            ))}
          </TableRow>
        ))
      ) : (
        <TableRow>
          <TableCell colSpan={table.getVisibleLeafColumns().length} className="text-center py-4">
            No divergence reports found.
          </TableCell>
        </TableRow>
      )}
    </>
  );
}
